import React from "react";
import {
  BestLabel,
  BestSelect,
  Icon,
  Input,
  LightButton,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeaderWithTitleAndClose,
  PrimaryButton,
  RequiredInput
} from "best-common-react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { inject, observer } from "mobx-react";
import { toJS } from "mobx";

const AddAll = styled.button`
  text-decoration: none !important;
`;

// add type and category
class AddTemporarySectionModal extends React.Component {
  render() {
    const { commonStore, temporarySectionStore } = this.props.rootStore;

    return (
      <Modal show={this.props.show} size="lg" onClose={this.props.onClose}>
        <ModalHeaderWithTitleAndClose
          title="Create Game-Specific Section"
          onClose={this.props.onClose}
          close={this.props.onClose}
        />
        <ModalBody>
          <div>
            <div className="row">
              <div className="col-sm-3 col-form-label text-nowrap py-0">
                <BestLabel required={true}>Section</BestLabel>
              </div>
              <div className="col-sm-9">
                <RequiredInput>
                  <Input
                    id="section-number"
                    name="sectionNumber"
                    onChange={event => {
                      temporarySectionStore.setSectionName(event.target.value);
                    }}
                    value={temporarySectionStore.sectionName}
                  />
                </RequiredInput>
              </div>
              <div className="col-xl-12 col-lg-6 col-md-12 mt-2">
                <div className="row form-group">
                  <div className="col-sm-3 col-form-label text-nowrap py-0">
                    <BestLabel required={true}>Type</BestLabel>
                  </div>
                  <div className="col-sm-9">
                    <RequiredInput>
                      <BestSelect
                        id="home-away"
                        options={commonStore.homeAwayOptions}
                        value={temporarySectionStore.sectionType}
                        onChange={value => {
                          temporarySectionStore.setSectionType(value);
                        }}
                      />
                    </RequiredInput>
                  </div>
                </div>
              </div>
              {temporarySectionStore.sectionType.label === "Umpires" && (
                <div className="col-xl-12 col-lg-6 col-md-12">
                  <div className="row form-group">
                    <div className="col-sm-3 col-form-label text-nowrap py-0">
                      <BestLabel required={true}>Category</BestLabel>
                    </div>
                    <div className="col-sm-9">
                      <RequiredInput>
                        <BestSelect
                          id="section-category"
                          options={commonStore.categoryTypesDropdown}
                          value={temporarySectionStore.umpireCategoryType}
                          onChange={value => {
                            temporarySectionStore.setUmpireCategoryType(value);
                          }}
                        />
                      </RequiredInput>
                    </div>
                  </div>
                </div>
              )}
              <div className="col">
                <BestLabel
                  className="my-2"
                  name="familyTicketAllocation"
                  label="Family Ticket Allocations"
                  required={true}
                >
                  Family Ticket Allocations
                </BestLabel>
                <AddAll
                  id="add-all"
                  className="btn btn-link btn-sm p-0 float-right"
                  onClick={() =>
                    temporarySectionStore.setSelectedFamilyDepartments(temporarySectionStore.departmentDropdown)
                  }
                >
                  Add All
                </AddAll>
                <BestSelect
                  isMulti
                  name="familyDepartments"
                  id="familyDepartments"
                  options={temporarySectionStore.departmentDropdown}
                  values={toJS(temporarySectionStore.familyDepartments)}
                  onChange={value => {
                    temporarySectionStore.setSelectedFamilyDepartments(value);
                  }}
                />
              </div>
              <div className="col">
                <BestLabel
                  className="my-2"
                  name="friendTicketAllocation"
                  label="Friend Ticket Allocations"
                  required={true}
                >
                  Friend Ticket Allocations
                </BestLabel>
                <AddAll
                  id="add-all"
                  className="btn btn-link btn-sm p-0 float-right"
                  onClick={() =>
                    temporarySectionStore.setSelectedFriendsDepartments(temporarySectionStore.departmentDropdown)
                  }
                >
                  Add All
                </AddAll>
                <BestSelect
                  isMulti
                  name="friendDepartments"
                  id="friendDepartments"
                  options={temporarySectionStore.departmentDropdown}
                  value={toJS(temporarySectionStore.friendsDepartments)}
                  onChange={value => {
                    temporarySectionStore.setSelectedFriendsDepartments(value);
                  }}
                />
              </div>
            </div>
            <React.Fragment>
              <BestLabel required={true} for="inventory">
                Price
              </BestLabel>
              <Input
                type="number"
                required={true}
                id="price"
                name="price"
                min="0"
                step="any"
                value={temporarySectionStore.price}
                onChange={e => temporarySectionStore.setPrice(e.target.value)}
              />
            </React.Fragment>
            <React.Fragment>
              <BestLabel required={true} for="numOfSeats">
                # of Seats
              </BestLabel>
              <Input
                type="number"
                required={true}
                id="numOfSeats"
                name="numOfseats"
                min="0"
                step="any"
                value={temporarySectionStore.numOfSeats}
                onChange={e => temporarySectionStore.setNumOfSeats(e.target.value)}
              />
            </React.Fragment>
          </div>
        </ModalBody>
        <ModalFooter>
          <div>
            <PrimaryButton
              className="mr-2"
              onClick={temporarySectionStore.saveSection}
              disabled={!temporarySectionStore.isValidSave}
            >
              Save
            </PrimaryButton>
            <LightButton onClick={this.props.onClose}>Cancel</LightButton>
          </div>
        </ModalFooter>
      </Modal>
    );
  }
}

export default inject("rootStore")(observer(AddTemporarySectionModal));
